import { FC, useCallback } from "react";
import { MinusCircledIcon, PlusCircledIcon } from "@smile2impress/components";
import {
    Box,
    Flex,
    Text,
    Accordion,
    AccordionItem,
    AccordionButton,
    AccordionPanel,
    Picture,
    Icon,
    Heading,
} from "@smile2impress/components/relaunch";

import { TreatmentInfoProps } from "./TreatmentInfo.types";

// todo: find a way to replace Questions component with this component
export const TreatmentInfo: FC<TreatmentInfoProps> = ({
    content: { title, subtitle, items },
}) => {
    const filteredItems = items.filter(({ title }) => title.length > 0);

    const accordionIconComponent = useCallback(
        (color: string, isExpanded: boolean) => (
            <Icon
                as={isExpanded ? MinusCircledIcon : PlusCircledIcon}
                w={["24px", "24px", "32px"]}
                h={["24px", "24px", "32px"]}
                color={color}
            />
        ),
        []
    );

    return (
        <Box>
            <Box px={[2, 2, 4]} mb={[3, 3, 4]}>
                <Heading
                    textStyle="title1"
                    maxW={["100%", "100%", "800px"]}
                    mb={1}
                    color="text.base"
                >
                    {title}
                </Heading>
                <Text textStyle="body" maxW={["100%", "100%", "700px"]}>
                    {subtitle}
                </Text>
            </Box>
            <Accordion
                variant="withImage"
                defaultIndex={[0]}
                allowToggle
                px={[0, 0, 4]}
            >
                {filteredItems.map((item, index) => (
                    <AccordionItem
                        key={`${item.title}-${index}`}
                        position="relative"
                    >
                        {({ isExpanded }: { isExpanded: boolean }) => (
                            <Box
                                {...(item.bg && isExpanded && { bg: item.bg })}
                            >
                                {item.image && (
                                    <Picture
                                        position="absolute"
                                        zIndex="0"
                                        display={isExpanded ? "block" : "none"}
                                        top={0}
                                        left={0}
                                        w="100%"
                                        h="100%"
                                        imageProps={{
                                            objectPosition: "right",
                                        }}
                                        sx={{
                                            "&::before": {
                                                content: '""',
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                bg: {
                                                    base: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 38.8%, rgba(0, 0, 0, 0.75) 95.43%)",
                                                    desktop: "none",
                                                },
                                                zIndex: 1,
                                            },
                                        }}
                                        {...item.image}
                                    />
                                )}
                                <AccordionButton
                                    display={"flex"}
                                    justifyContent="space-between"
                                    p={[2, 2, 3]}
                                    position="relative"
                                    zIndex={1}
                                    _hover={
                                        isExpanded && item.image
                                            ? {
                                                  bg: "none",
                                              }
                                            : {}
                                    }
                                >
                                    <Text
                                        textStyle="H3"
                                        textAlign="left"
                                        textTransform="uppercase"
                                        as="span"
                                        flex="1"
                                    >
                                        {!isExpanded && item.title}
                                    </Text>
                                    {accordionIconComponent(
                                        isExpanded
                                            ? "text.baseInverse"
                                            : "base.gunmetal",
                                        isExpanded
                                    )}
                                </AccordionButton>
                                <AccordionPanel
                                    minH={isExpanded ? "212px" : "initial"}
                                >
                                    <Flex
                                        flex="1"
                                        flexDirection="column"
                                        zIndex={1}
                                    >
                                        <Flex
                                            flex="1"
                                            flexDirection="column"
                                            justifyContent="flex-end"
                                            maxW={["85%", "85%", "30%"]}
                                        >
                                            <Text
                                                textStyle="H3"
                                                textTransform="uppercase"
                                                color="text.baseInverse"
                                                mb={1}
                                                textShadow="base"
                                            >
                                                {item.title}
                                            </Text>
                                            <Text
                                                textStyle="body"
                                                color="text.baseInverse"
                                                textShadow="base"
                                            >
                                                {item.description}
                                            </Text>
                                        </Flex>
                                    </Flex>
                                </AccordionPanel>
                            </Box>
                        )}
                    </AccordionItem>
                ))}
            </Accordion>
        </Box>
    );
};
